import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  NotificationData,
  NotificationService,
} from '../services/notification.service';
import { Subscription } from 'rxjs';

const AUTO_DISMISS_MS = 5500;
const MAX_VISIBLE = 8;

interface NotificationEntry {
  id: number;
  data: NotificationData;
}

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  notifications: NotificationEntry[] = [];
  private sub!: Subscription;
  private dismissTimers = new Map<number, ReturnType<typeof setTimeout>>();
  private nextId = 0;

  constructor(
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.sub = this.notificationService.notification$.subscribe((notif) => {
      const id = this.nextId++;
      this.notifications.push({ id, data: notif });
      if (this.notifications.length > MAX_VISIBLE) {
        const removed = this.notifications.splice(
          0,
          this.notifications.length - MAX_VISIBLE,
        );
        removed.forEach((entry) => this.clearTimer(entry.id));
      }
      this.scheduleAutoDismiss(id);
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.dismissTimers.forEach((timer) => clearTimeout(timer));
    this.dismissTimers.clear();
  }

  dismissById(id: number): void {
    this.clearTimer(id);
    const index = this.notifications.findIndex((n) => n.id === id);
    if (index >= 0) {
      this.notifications.splice(index, 1);
      this.cdr.detectChanges();
    }
  }

  private scheduleAutoDismiss(id: number): void {
    const timer = setTimeout(() => this.dismissById(id), AUTO_DISMISS_MS);
    this.dismissTimers.set(id, timer);
  }

  private clearTimer(id: number): void {
    const timer = this.dismissTimers.get(id);
    if (timer) {
      clearTimeout(timer);
      this.dismissTimers.delete(id);
    }
  }
}
